import axios from 'axios'
export const baseUrl = process.env.VUE_APP_BASE_URL

const path = window.location.pathname;
export const basePath = baseUrl + process.env.NODE_ENV == "development" ? '/elearning' : path.split('/public/')[0]
export const basePathUrl = basePath + '/servlet/api/v1/';
// 資源url
export const serverUrl = process.env.NODE_ENV == "development" ? `http://app.metaarchit.com${basePath}` : baseUrl + basePath;

axios.defaults.baseURL = baseUrl + basePathUrl;

// axios.defaults.withCredentials = true;
axios.defaults.timeout = 20000
axios.interceptors.request.use(
    config => {
        if (config.url.indexOf('/captcha') != -1) {
            config.baseURL = basePath
        }
        return config
    },
    err => {
        return Promise.reject(err)
    }
)

import router from "../router"
axios.interceptors.response.use(
    (response) => {
        return response
    }, (err) => {
        const response = err.response
        const data = response.data || {}
        if (response.status && response.status == 403) {
            sessionStorage.setItem('logout',true);
            // production跳轉一互通，測試環境跳轉本地login頁面
            // window.location.href = baseUrl + basePathUrl + 'oauth/authorize';
            // production跳轉一互通，測試環境跳轉本地login頁面
            if (process.env.NODE_ENV == 'production') {
                // if (confirm(response.status)) {
                var lang = localStorage.getItem('lan') || 'ZH_TW';
                window.location.href = baseUrl + basePathUrl + `oauth/authorize?lang=${lang}`;
                // }
            } else {
                router.push('/login');
            }

        }
        return Promise.reject({
            status: response.status,
            code: data.code,
            message: data.message,
            data: data,
            raw: err
        })
    }
)

export default axios